export enum AutomationRoutes {
  index = 'user.automations',
  flows = 'user.automations.flows',
  flowDetails = 'user.automations.flowDetails',
  templates = 'user.automations.templates',
  logs = 'user.automations.logs',
}
